export default __webpack_public_path__ + "static/sustainability-2-a288043528d94371b0603b8d10407fa0.jpg";